import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  MinimumRoll, UpgradableNumber
} from "@dndModels";
import { 
  ATTACK_TYPES 
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

type Props = {
  obj: MinimumRoll;
  onChange: (changed: MinimumRoll) => void; 
  disabled: boolean;
  attached_table?: AttachedTable;
}

export interface State { 
  reloading: boolean;
}

const ability_checks = [
  "STR Check",
  "DEX Check",
  "CON Check",
  "INT Check",
  "WIS Check",
  "CHA Check"
];
const saves = [
  "STR Save",
  "DEX Save",
  "CON Save",
  "INT Save",
  "WIS Save",
  "CHA Save"
];

class MinimumRollInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      reloading: false,
    };
  }

  componentDidMount() {
  }

  render() {
    let extra_options: string[] = [];
    if (this.props.obj.types.includes("ability")) {
      extra_options = ability_checks;
    }
    if (this.props.obj.types.includes("save")) {
      extra_options = [...extra_options,...saves];
    }
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name="Types" 
            options={[
              { id: "ability", text: "Ability", disabled: false, reason: "" },
              { id: "skill", text: "Skill", disabled: false, reason: "" },
              { id: "save", text: "Saving Throw", disabled: false, reason: "" },
              { id: "attack", text: "Attack", disabled: false, reason: "" },
            ]}
            values={this.props.obj.types} 
            multiple
            disabled={this.props.disabled}
            onChange={(values: string[]) => {
              const obj = this.props.obj;
              obj.types = values;
              this.props.onChange(obj);
              this.setState({ reloading: true }, () => {
                this.setState({ reloading: false });
              })
            }} 
          />
        </Grid>
        { (this.props.obj.types.filter(o => !["ability","save","attack"].includes(o)).length > 0 || extra_options.length > 0) &&
          <Grid
            size={{
              xs: 12
            }}>
            Not Implemented
            {/* { !this.state.reloading &&
              <SelectObjectBox
                name="Specifics"
                data_types={this.props.obj.types.filter(o => !["ability","save","attack"].includes(o))}
                values={this.props.obj.ids}
                extra_options={extra_options}
                multiple
                // log_it
                disabled={this.props.disabled}
                onChange={(values: string[]) => {
                  const obj = this.props.obj;
                  obj.ids = values;
                  this.props.onChange(obj);
                }}
              />
            } */}
          </Grid>
        }
        { this.props.obj.types.includes("attack") &&
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox 
              name="Attack Types" 
              options={ATTACK_TYPES}
              values={this.props.obj.attack_types} 
              multiple
              disabled={this.props.disabled}
              onChange={(values: string[]) => {
                const obj = this.props.obj;
                obj.attack_types = values;
                this.props.onChange(obj);
              }} 
            />
          </Grid>
        }
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox 
            name="Required Proficiency Threshold" 
            options={
              [
                { id: "0", text: "None", disabled: false, reason: "" },
                { id: "1", text: "Proficient", disabled: false, reason: "" },
                { id: "2", text: "Expert", disabled: false, reason: "" }
              ]
            }
            value={`${this.props.obj.proficiency_level}`} 
            disabled={this.props.disabled}
            onChange={(value: string) => {
              const obj = this.props.obj;
              obj.proficiency_level = +value;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <UpgradableNumberBox 
            name="Threshold" 
            value={this.props.obj.threshold}
            disabled={this.props.disabled}
            attached_table={this.props.attached_table}
            onChange={(value: UpgradableNumber) => {
              const obj = this.props.obj;
              obj.threshold = value.clone();
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            name="When" 
            value={this.props.obj.when} 
            disabled={this.props.disabled}
            onBlur={(value: string) => {
              const obj = this.props.obj;
              obj.when = value;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}

export default MinimumRollInput;
